<div class="d-inline-flex">
  <ncp-button
    #btn
    [options]="btnOptions()"
  />
  <ncp-modal
    #mod
    [options]="modOptions()"
  />
</div>
